import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/redux/hooks";
import {
  resetMySiteGalleryStatus,
  resetMySitePhoneStatus,
  resetMySitePhotoStatus,
  resetMySiteSliderStatus,
  resetMySiteSocialMediaStatus,
  resetMySiteTextStatus,
  resetMySiteVideoStatus,
  resetRemoveWebsitePartitionStatus,
  selectMySiteDetails,
  selectMySiteGallery,
  selectMySiteGalleryStatus,
  selectMySitePhone,
  selectMySitePhoneStatus,
  selectMySitePhoto,
  selectMySitePhotoStatus,
  selectMySiteSlider,
  selectMySiteSliderStatus,
  selectMySiteSocialMedia,
  selectMySiteSocialMediaStatus,
  selectMySiteText,
  selectMySiteTextStatus,
  selectMySiteVideo,
  selectMySiteVideoStatus,
  selectRemovedWebsitePartitionStatus,
} from "../../../slices/mySiteSlice";
import { toast } from "react-toastify";
import { ApiStatus } from "../../../models/app/apiStatus";

const useNotificationMessagessEffect = () => {
  const dispatch = useAppDispatch();
  const mySitePartitionsStatus = {
    photo: useAppSelector(selectMySitePhotoStatus),
    phone: useAppSelector(selectMySitePhoneStatus),
    text: useAppSelector(selectMySiteTextStatus),
    video: useAppSelector(selectMySiteVideoStatus),
    socialMedia: useAppSelector(selectMySiteSocialMediaStatus),
    gallery: useAppSelector(selectMySiteGalleryStatus),
    slider: useAppSelector(selectMySiteSliderStatus),
    removePartition: useAppSelector(selectRemovedWebsitePartitionStatus),
  };
  const mySitePartitions = useAppSelector((state) => ({
    photo: selectMySitePhoto(state),
    phone: selectMySitePhone(state),
    text: selectMySiteText(state),
    video: selectMySiteVideo(state),
    socialMedia: selectMySiteSocialMedia(state),
    gallery: selectMySiteGallery(state),
    slider: selectMySiteSlider(state),
    websiteDetails: selectMySiteDetails(state),
  }));
  useEffect(() => {
    if (mySitePartitionsStatus.text === ApiStatus.Fulfilled) {
      toast.success("Uspesno ste sacuvali text!", {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteTextStatus());
        },
      });
    } else if (mySitePartitionsStatus.phone === ApiStatus.Fulfilled) {
      toast.success("Uspesno ste sacuvali telefon!", {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySitePhoneStatus());
        },
      });
    } else if (mySitePartitionsStatus.photo === ApiStatus.Fulfilled) {
      toast.success("Uspesno ste sacuvali fotografiju!", {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySitePhotoStatus());
        },
      });
    } else if (mySitePartitionsStatus.video === ApiStatus.Fulfilled) {
      toast.success("Uspesno ste sacuvali video!", {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteVideoStatus());
        },
      });
    } else if (mySitePartitionsStatus.socialMedia === ApiStatus.Fulfilled) {
      toast.success("Uspesno ste sacuvali drustvene mreze!", {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteSocialMediaStatus());
        },
      });
    } else if (mySitePartitionsStatus.gallery === ApiStatus.Fulfilled) {
      toast.success("Uspesno ste sacuvali galeriju fotografija!", {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteGalleryStatus());
        },
      });
    } else if (mySitePartitionsStatus.slider === ApiStatus.Fulfilled) {
      toast.success("Uspesno ste sacuvali slajder!", {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteSliderStatus());
        },
      });
    } else if (mySitePartitionsStatus.removePartition === ApiStatus.Fulfilled) {
      toast.success("Uspesno ste obrisali particiju", {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetRemoveWebsitePartitionStatus());
        },
      });
    }
  }, [
    mySitePartitionsStatus.text,
    mySitePartitionsStatus.phone,
    mySitePartitionsStatus.photo,
    mySitePartitionsStatus.video,
    mySitePartitionsStatus.socialMedia,
    mySitePartitionsStatus.gallery,
    mySitePartitionsStatus.slider,
    mySitePartitionsStatus.removePartition,
  ]);
};

export default useNotificationMessagessEffect;
